module.exports = __webpack_public_path__ + "img/gift-friend-title.686bcbbd.png";